import React from 'react';

const BlogPage = () => {
  return (
    <div style={{ paddingTop: '80px', minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem', color: '#dc2626' }}>Our Blog</h1>
        <p style={{ fontSize: '1.2rem' }}>Digital marketing insights and tips coming soon!</p>
      </div>
    </div>
  );
};

export default BlogPage;